import { ASSETS_TYPES } from '@modules/consolidator/constants/Assets'

export const REGISTER_ASSET_TYPES = {
  PERSONALIZADO: ASSETS_TYPES.PERSONALIZADO,
  CASHBACK: ASSETS_TYPES.CASHBACK,
  ACAO: 'Ação',
  FUNDOS: ASSETS_TYPES.FUNDOS,
  FII: 'FII',
  OPERACOES_ESTRUTURADAS: 'Operações Estruturadas',
  RENDA_FIXA: 'Renda Fixa',
  TESOURO_DIRETO: 'Tesouro Direto',
  SALDO_EM_CONTA: 'Saldo em Conta',
  CAMBIO: 'Câmbio',
  OFFSHORE: ASSETS_TYPES.ACOES_OFFSHORE,
  BONDS: ASSETS_TYPES.BONDS,
  FUNDOS_OFFSHORE: ASSETS_TYPES.FUNDOS_OFFSHORE,
  CRIPTOATIVOS: ASSETS_TYPES.CRIPTO,
}

export const REGISTER_ASSET_FORM_COMPONENT_MAP = {
  [REGISTER_ASSET_TYPES.PERSONALIZADO]: 'AssetFormPersonalizado',
  [REGISTER_ASSET_TYPES.CASHBACK]: 'AssetFormCashback',
  [REGISTER_ASSET_TYPES.ACAO]: 'AssetFormAcao',
  [REGISTER_ASSET_TYPES.FUNDOS]: 'AssetFormFundos',
  [REGISTER_ASSET_TYPES.FII]: 'AssetFormFii',
  [REGISTER_ASSET_TYPES.OPERACOES_ESTRUTURADAS]:
    'AssetFormOperacoesEstruturadas',
  [REGISTER_ASSET_TYPES.RENDA_FIXA]: 'AssetFormRendaFixa',
  [REGISTER_ASSET_TYPES.OFFSHORE]: 'AssetFormOffshore',
  [REGISTER_ASSET_TYPES.BONDS]: 'AssetFormBonds',
  [REGISTER_ASSET_TYPES.FUNDOS_OFFSHORE]: 'AssetFormFundosOffshore',
  [REGISTER_ASSET_TYPES.CAMBIO]: 'AssetFormCambio',
  [REGISTER_ASSET_TYPES.TESOURO_DIRETO]: 'AssetFormTesouroDireto',
  [REGISTER_ASSET_TYPES.SALDO_EM_CONTA]: 'AssetFormSaldoEmConta',
  [REGISTER_ASSET_TYPES.CRIPTOATIVOS]: 'AssetFormCriptoativos',
}

export const REGISTER_ASSET_TYPE_OPTIONS = [
  REGISTER_ASSET_TYPES.PERSONALIZADO,
  REGISTER_ASSET_TYPES.CASHBACK,
  REGISTER_ASSET_TYPES.ACAO,
  REGISTER_ASSET_TYPES.FUNDOS,
  REGISTER_ASSET_TYPES.FII,
  REGISTER_ASSET_TYPES.OPERACOES_ESTRUTURADAS,
  REGISTER_ASSET_TYPES.RENDA_FIXA,
  REGISTER_ASSET_TYPES.TESOURO_DIRETO,
  REGISTER_ASSET_TYPES.SALDO_EM_CONTA,
  REGISTER_ASSET_TYPES.OFFSHORE,
  REGISTER_ASSET_TYPES.BONDS,
  REGISTER_ASSET_TYPES.CAMBIO,
  REGISTER_ASSET_TYPES.FUNDOS_OFFSHORE,
  REGISTER_ASSET_TYPES.CRIPTOATIVOS,
]

export const REGISTER_ASSET_FORCED_QUANTITY_TYPES = [
  REGISTER_ASSET_TYPES.ACAO,
  REGISTER_ASSET_TYPES.FII,
  REGISTER_ASSET_TYPES.OPERACOES_ESTRUTURADAS,
  REGISTER_ASSET_TYPES.OFFSHORE,
  REGISTER_ASSET_TYPES.BONDS,
  REGISTER_ASSET_TYPES.CAMBIO,
  REGISTER_ASSET_TYPES.FUNDOS_OFFSHORE,
  REGISTER_ASSET_TYPES.CRIPTOATIVOS,
]

export const REGISTER_ASSET_TYPE_DIRECT_MAP = {
  outros: REGISTER_ASSET_TYPES.OPERACOES_ESTRUTURADAS,
  rf: REGISTER_ASSET_TYPES.RENDA_FIXA,
  cambio: REGISTER_ASSET_TYPES.CAMBIO,
}

export const REGISTER_ASSET_TYPE_SYNONYMS_MAP = {
  fundos: REGISTER_ASSET_TYPES.FUNDOS,
  'fundos de investimento': REGISTER_ASSET_TYPES.FUNDOS,
  'fundos de investimentos': REGISTER_ASSET_TYPES.FUNDOS,
  'fundos de previdencia': REGISTER_ASSET_TYPES.FUNDOS,
  acoes: REGISTER_ASSET_TYPES.ACAO,
  acao: REGISTER_ASSET_TYPES.ACAO,
  'fundos imobiliarios': REGISTER_ASSET_TYPES.FII,
  'fundo imobiliario': REGISTER_ASSET_TYPES.FII,
  'saldo em conta': REGISTER_ASSET_TYPES.SALDO_EM_CONTA,
  cripto: REGISTER_ASSET_TYPES.CRIPTOATIVOS,
  criptoativo: REGISTER_ASSET_TYPES.CRIPTOATIVOS,
  criptoativos: REGISTER_ASSET_TYPES.CRIPTOATIVOS,
  'acoes offshore': REGISTER_ASSET_TYPES.OFFSHORE,
  'fundos offshore': REGISTER_ASSET_TYPES.FUNDOS_OFFSHORE,
}
